import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit, OnDestroy {
  public isLoginPage = true;
  public logo = environment.logo;
  public subscription: Subscription;
  constructor(private router: Router, private splashScreen: SplashScreen, private platform: Platform) {}

  ngOnInit() {
    this.subscription = this.router.events.subscribe((event: NavigationEnd) => {
      if (event.url) {
        const url = event.url.split('/');
        this.isLoginPage = url[url.length - 1] !== 'recuperar-senha';
        this.logo = this.isLoginPage ? environment.logo : environment.recoveryLogo;
      }
    });
    this.platform.ready().then(() => {
      this.splashScreen.hide();
    });
  }

  goToLogin() {
    this.router.navigate(['']);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
